import { motion } from "framer-motion";
import { Atom, BatteryCharging, ShieldCheck, Droplets } from "lucide-react";

const ICONS = [BatteryCharging, Atom, ShieldCheck, Droplets];

export function ScienceSection({ chapters }) {
  return (
    <section id="ciencia" className="py-24 lg:py-32 bg-[#0D130F]/60 border-y border-emerald-500/10" data-testid="science-section">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }} className="mb-14 max-w-2xl">
          <span className="text-xs uppercase tracking-[0.25em] text-emerald-400 font-medium">La Ciencia</span>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight mt-3">
            Manifiesto <span className="text-emerald-gradient">celular</span>
          </h2>
          <p className="text-gray-400 mt-4 leading-relaxed">Cuatro pilares que separan a 365 Cellular Energy de cualquier suplemento genérico.</p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6">
          {(chapters || []).map((c, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                className="relative rounded-2xl border border-emerald-500/15 bg-[#050806] p-7 hover:border-yellow-600/35 transition-colors duration-300 group"
                data-testid={`science-chapter-${i}`}
              >
                <span className="font-mono text-5xl font-bold text-emerald-500/12 absolute top-5 right-6 group-hover:text-yellow-600/20 transition-colors duration-300">{c.num}</span>
                <div className="w-11 h-11 rounded-xl bg-emerald-500/10 border border-emerald-500/25 flex items-center justify-center mb-5">
                  <Icon className="w-5 h-5 text-emerald-400" />
                </div>
                <h3 className="font-display text-xl sm:text-2xl font-semibold tracking-tight">{c.title}</h3>
                <p className="text-gray-400 mt-3 leading-relaxed text-sm sm:text-base">{c.text}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
